import GeneralSettingsTab from './general-settings';

export default GeneralSettingsTab;
